export default __webpack_public_path__ + "static/media/assist_web-xs@1x.3133c34c.webp";